import type { TaxBracket, TaxRebate, TaxThresholds, TaxYear } from '../../../types/tax';
import { BaseTaxYearStrategy } from '../TaxYearStrategy';
import {
  TAX_BRACKETS_2024_25,
  TAX_REBATES_2024_25,
  TAX_THRESHOLDS_2024_25,
  ANNUAL_MEDICAL_AID_CREDITS_2024_25,
  TAX_YEAR_START,
  TAX_YEAR_END
} from '../../../data/tax';

export class TaxYear2024_25Strategy extends BaseTaxYearStrategy {
  getYear(): TaxYear {
    return '2024-25';
  }
  
  getDisplayName(): string {
    return '2024-2025 Tax Year (Current)';
  }
  
  getTaxBrackets(): TaxBracket[] {
    return TAX_BRACKETS_2024_25;
  }
  
  getTaxRebates(): TaxRebate {
    return TAX_REBATES_2024_25;
  }
  
  getTaxThresholds(): TaxThresholds {
    return TAX_THRESHOLDS_2024_25;
  }
  
  getMedicalAidCredits(): { mainMember: number; firstDependent: number; additionalDependent: number; } {
    return {
      mainMember: ANNUAL_MEDICAL_AID_CREDITS_2024_25.mainMember,
      firstDependent: ANNUAL_MEDICAL_AID_CREDITS_2024_25.firstDependent,
      additionalDependent: ANNUAL_MEDICAL_AID_CREDITS_2024_25.additionalDependent
    };
  }
  
  getStartDate(): Date {
    return new Date(TAX_YEAR_START);
  }
  
  getEndDate(): Date {
    return new Date(TAX_YEAR_END);
  }
}